module.exports = __webpack_public_path__ + "static/media/multiStyle_icon.c6c2fc2a.svg";